import { render, staticRenderFns } from "./TemplateItems.vue?vue&type=template&id=b38baa5c&"
import script from "./TemplateItems.vue?vue&type=script&lang=js&"
export * from "./TemplateItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports